import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from './../../../../environments/environment';
import { Observable } from 'rxjs';
import { IResponse } from '../utilities/response.model';

@Injectable({
    providedIn: 'root'
})
export class CreditSimulatorService {
    private API_URL: string;
    private endpoint: string;

    constructor(private http: HttpClient) {
        this.API_URL = environment.urlApi;
        this.endpoint = `${this.API_URL}/portal/credit-applications`;
    }

    public getCotizacionInicial(amount: number, plazo: number): Observable<IResponse> {
        return this.http.get<IResponse>(`${this.endpoint}/cotizacion-inicial?amount=${amount}&plazo=${plazo}`);
    }
}
